module.exports = __webpack_public_path__ + "static/media/GoldMedal.cc0a1339.png";